import { HistoricalPermitPopupVariant } from 'pages/insights/auditLog/components/historicalPermitPopup/constants'

export const getHistoricalPermitPopupTitle = (variant: HistoricalPermitPopupVariant, identifierValue: string) => {
  switch (variant) {
    case HistoricalPermitPopupVariant.Consent:
      return `Consent History for "${identifierValue}"`
    case HistoricalPermitPopupVariant.Subscription:
      return `Subscription History for "${identifierValue}"`
  }
}
